import { render, staticRenderFns } from "./Dialog-editLicense.vue?vue&type=template&id=c5480efa&"
import script from "./Dialog-editLicense.vue?vue&type=script&lang=js&"
export * from "./Dialog-editLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports